import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const { protocol, host, port } = window.location;

export const metadataApi = createApi({
    reducerPath: 'metadataReducer',
    baseQuery: fetchBaseQuery({
        baseUrl: `${protocol}//${host}${port.length > 0 ? '' : `:${port}`}/api/ddiapi/v2`,
    }),
    endpoints: () => ({}),
});
